import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import HealthCheck from './components/HealthCheck'
import HealthCheckOpti from './components/HealthCheckOpti'
import NotFoundView from './components/404.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'

// Import module routes
import QuoteRoutes from './modules/quote/routes'
import SettingsRoutes from './modules/settings/routes'
import LibraryRoutes from './modules/library/routes'
import AdminRoutes from './modules/admin/routes'
import RateAssistRoutes from './modules/rateassist/routes'
import TariffMergeRoutes from './modules/tariffmerge/routes'

import store from './store'
import event from './event.js'
import { handleNext } from './modules/helpers/RouteHelpers'

// Routes
const routes = [
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: {description: 'Overview of Environment'},
        beforeEnter: (to, from, next) => {
          event.$emit('loading-on', {})
          const countLocation = store.dispatch('stats/getCountData', 'location')
          const countJob = store.dispatch('stats/getCountData', 'job')
          const countMaiUser = store.dispatch('stats/getCountData', 'mai-user')
          const countParty = store.dispatch('stats/getCountData', 'party')
          const recentJobs = store.dispatch('stats/getRecentEntities', 'job')
          const dO = store.dispatch('systemOption/initialise')
          handleNext([dO, countLocation, countJob, countMaiUser, countParty, recentJobs], next)
        }
      },
      ...QuoteRoutes,
      ...SettingsRoutes,
      ...LibraryRoutes,
      ...AdminRoutes,
      ...RateAssistRoutes,
      ...TariffMergeRoutes
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/health-check',
    name: 'HealthCheck',
    component: HealthCheck
  },
  {
    path: '/health-check/opti',
    name: 'HealthCheckOpti',
    component: HealthCheckOpti
  },
  {
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js